import expcardimg1 from "./../images/waveauth.png";
import expcardimg2 from "./../images/turninglabs.png";
import expcardimg3 from "./../images/h1.jpg";

const ExpData = [
  {
    id: 1,
    title: "WaveAuth",
    role: "Full Stack Intern",
    loc: "remote",
    date: "FEB 2023 - MAY 2023",
    img: expcardimg1,
    classDis: "expcard1 expcard",
    color: "linear-gradient(80deg, #2ecd3d, #1ed16c)",
    details:
      "● Designed and created: <a href='https://waveauth.tech' target='_blank'>WaveAuth.tech</a><br/><br/>● Implemented my Web Development skills to create a stunning attractive website for a startup.<br><br>● Built and coordinated with JAVA developers to create a fully functional passwordless service.<br><br>● Tech Stack:- ReactJS, JavaScript, NextJS, SwiperJS, Git, Github<br/><br/>",
  },
  {
    id: 2,
    title: "Turing Techlabs",
    role: "Freelancing",
    loc: "REMOTE",
    date: "MAR 2022 - APR 2022",
    img: expcardimg2,
    classDis: "expcard2 expcard ",
    color: "#000",
    details:
      "● Designed and created:<a href='https://healthcare-service.netlify.app/' target='_blank'> Healtcare</a><br/><br/>● Coordinated with Turing TechLabs to deliver an amazing website for a Hospital.<br/><br/>● ShreeArogyam Ayu: Created a fully customized React-based website, enhancing the online presence.<br/><br/>● Tech Stack:- ReactJS, JavaScript, Git, Github<br/><br/>",
  },
  {
    id: 3,
    title: "Bug Bounty Hunter",
    role: "Freelancing",
    loc: "REMOTE",
    date: "SEPT 2021 - Current",
    img: expcardimg3,
    classDis: "expcard1 expcard",
    color: "purple",
    details:
      "● Part time bug bounty hunter<br/><br/>● Responsibly disclosed multiple medium and high level severity bugs. <br/><br/>● Founded Bugs: XSS, IDOR,Domain takeover, File Uploads<br/><br/>● Hacked companies like ABB.com, American System, PCET ERP, etc.",
  },
];

export default ExpData;
